// extracted by mini-css-extract-plugin
module.exports = {"Container":"Container_lgE6X","ContentContainer":"ContentContainer_EjaQZ"};